import { render, staticRenderFns } from "./QuickReply.vue?vue&type=template&id=984e2d38&scoped=true&"
import script from "./QuickReply.vue?vue&type=script&lang=js&"
export * from "./QuickReply.vue?vue&type=script&lang=js&"
import style0 from "./QuickReply.vue?vue&type=style&index=0&id=984e2d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984e2d38",
  null
  
)

export default component.exports